export default __webpack_public_path__ + "static/media/2-StrandedMooring.094040b9.jpeg";